export const theme = {
  colors: {
    active: '#005EEB',
    error: '#db0000',
    success: '#05a500',
    warn: '#ffcc00',

    bg: {
      primary: '#002047',
      secondary: '#ffffff',
      lightGrey: '#BEBEBE',
      grey: '#DDDDDD',
      tableGrey: '#b4b4b4',
      coffeeGrey: '#7e7e7e',
      darkGrey: '#4A4A4A',
    },
    decors: {
      white: '#ffffff',
      black: '#000000',
      lightGrey: '#e3e3e3',
      grey: '#ACACAC',
      darkGrey: '#4A4A4A',
      highlight: '#805cee',
      shiftTaken: 'rgba(146,243,65,0.8)',
    },
    text: {
      white: '#ffffff',
      black: '#000000',
      grey: '#767676',
      darkGrey: '#4E4E4E',
      routeSelected: '#C70000',
    },
  },
  fontSize: {
    l: '2.4rem',
    m: '2.0rem',
    s: '1.6rem',
    xs: '1.4rem',
    xxs: '1.2rem',
  },
  fontWeight: {
    light: 300,
    regular: 400,
    bold: 700,
    heavy: 800,
  },
};
